module.exports = __webpack_public_path__ + "media/theme/nintendo-43f0bdbf.png";